import { NgModule }                    from '@angular/core';
import { AccessFlowCheckDirective }    from '@shared/directives/access-flow-check.directive';
import { DomTreeChangedDirective }     from '@shared/directives/dom-tree-changed.directive';
import { DragDropFilesDirective }      from '@shared/directives/drag-drop-files.directive';
import { HighlightTextDirective }      from '@shared/directives/highlight-text.directive';
import { IndicateElsterFieldModule }   from '@shared/directives/indicate-elster-field/indicate-elster-field.module';
import { LimitHandlerDirective }       from '@shared/directives/limit-handler.directive';
import { MatchHeightDirective }        from '@shared/directives/match-height.directive';
import { NgbTooltipExtendedDirective } from '@shared/directives/ngb-tooltip-extended.directive';
import { ScrollEventDirective }        from '@shared/directives/scroll-event.directive';
import { SetAttributeDirective }       from '@shared/directives/set-attribute.directive';
import { ToggleFullscreenDirective }   from '@shared/directives/toggle-fullscreen.directive';
import { VarDirective }                from '@shared/directives/var.directive';


@NgModule( {
	declarations: [
		AccessFlowCheckDirective,
		DragDropFilesDirective,
		DomTreeChangedDirective,
		HighlightTextDirective,
		LimitHandlerDirective,
		MatchHeightDirective,
		NgbTooltipExtendedDirective,
		SetAttributeDirective,
		ScrollEventDirective,
		ToggleFullscreenDirective,
		VarDirective
	],
	exports: [
		AccessFlowCheckDirective,
		DragDropFilesDirective,
		DomTreeChangedDirective,
		HighlightTextDirective,
		IndicateElsterFieldModule,
		LimitHandlerDirective,
		MatchHeightDirective,
		NgbTooltipExtendedDirective,
		SetAttributeDirective,
		ScrollEventDirective,
		ToggleFullscreenDirective,
		VarDirective
	]
} )
export class DirectivesModule {}
